export const INVOICE_DUE_DATE_VALUES = {
  EOM: -1,
  '0': 0,
  '15': 15,
  '30': 30,
  '45': 45,
  '60': 60,
  '90': 90,
  '120': 120,
};
